import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Connexion réussie");
            const from = location.state?.from;
            if (res.user.role === "admin") navigate("/admin/demandes");
            else navigate(from && from !== "/connexion" ? from : "/tarifs");
        } else {
            setError(res.error);
        }
    };

    return (
        <section className="max-w-md mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="login-page">
            <p className="bc-label-small">Espace Pro</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Se connecter</h1>
            <div className="bc-hairline-gold my-6" />
            <p className="text-[#F2ECE0]/80 text-sm">
                Accédez à vos tarifs et suggestions professionnels.
            </p>

            <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
                <div>
                    <label className="bc-label">E-mail</label>
                    <input
                        type="email"
                        required
                        className="bc-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        data-testid="login-email"
                    />
                </div>
                <div>
                    <label className="bc-label">Mot de passe</label>
                    <input
                        type="password"
                        required
                        className="bc-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        data-testid="login-password"
                    />
                </div>

                {error && (
                    <div
                        className="border px-4 py-3 text-sm"
                        style={{ borderColor: "rgba(217,112,112,0.6)", color: "#ffb0b0", background: "#1a0a0a" }}
                        data-testid="login-error"
                    >
                        {error}
                    </div>
                )}

                <button type="submit" className="bc-btn w-full" disabled={loading} data-testid="login-submit">
                    {loading ? "Connexion..." : "Se connecter"}
                </button>
            </form>

            <div className="mt-10 flex flex-col gap-3 text-sm">
                <Link to="/mot-de-passe-oublie" className="text-[#D4BC7C] hover:underline" data-testid="link-forgot">
                    Mot de passe oublié ?
                </Link>
                <Link to="/inscription" className="text-[#F2ECE0]/70 hover:text-[#D4BC7C]" data-testid="link-register">
                    Pas encore de compte ? Demander l'accès
                </Link>
            </div>
        </section>
    );
}
